// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"1f4bdbe9","290":"50bcc343","485":"53350e49","526":"8e3c5456","634":"b4e0b950","679":"9d6dc303","728":"40a2a973","801":"fc98edd5"}[chunkId] + ".chunk.js";
};